import { PulseLoader } from 'react-spinners';

function Loader(props) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <PulseLoader color="#2196f3" size={15} margin={2} loading={props.loading}/>
    </div>
  );
}
export default Loader;